import styled from 'styled-components';
import { gridSizes } from 'utils/style';
import Comments from './Comments';

export default styled(Comments)`
  .label {
    color: var(--grey700);
    margin: 0;
  }

  .comments {
    margin: ${gridSizes('XS')} 0 0 0;
    font-style: italic;
    color: var(--grey700);
    overflow: hidden;
    font-family: Roboto;
  }

  h3 {
    font-weight: 500;
    font-size: 2.4rem;
    margin: ${gridSizes('M')} 0;
  }

  button {
    text-decoration: underline;
    height: 100%;
  }
`;
